<template>
<div>
    <div v-show="false">{{touch}}</div>
    <template v-for="(state,widget_name) in triggered">
        <div v-if="state===true" :key="'widget_qid_'+qid+'_'+widget_name">
            <component
                :key="'qid_'+qid+'_'+widget_name"   
                :is="widget_name"
                :question="question"
                :questionMap="questionMap"
                :triggers="triggerResults[widget_name]"
                :debug="debug"
                @widgetRequest="widgetRequest"
            />
        </div>
    </template>
</div>
</template>

<script>
import guidelines from './widgets/guidelines';
import patient_summary from './widgets/patient_summary';

const loader = require("./../../../lib/loader.js").default;
var module_config = loader('patient-survey-widgets');
module_config.components = {
    guidelines,
    patient_summary
}
export default module_config;
</script>

<style>

</style>